import type { MigrationStrategies } from 'rxdb';
import MigrationHelper from '../MigrationHelper';
import type { DeficiencyList } from './deficiencyList.types';

export const deficiencyListMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: DeficiencyList) => {
    const newDoc = {
      role: 7,
      ...oldDoc,
    };
    return newDoc;
  },
  2: (oldDoc: DeficiencyList) => {
    return MigrationHelper.instance.migrateDeficiencyV2(oldDoc).then(response => {
      if (response && response.componentVersionUUID) return { ...oldDoc, ...response };
      // if componentVersionUUID is not present, do not migrate data
      return null;
    });
  },
};
